//* 组件库
import type { UiTableOption2 } from "various-ui";
//* 样式
import css from "../style/index.module.less";

export const useOptions = () => {
    //* 获取i18n
    const i18n = useI18n();

    return {
        //* 表格配置
        view: <UiTableOption2[]>[
            { name: "#", key: "index", align: "center" },
            { name: i18n.t('Categorization'), "key": "classification", align: "center", "extra": true, "extra-name": css.checkboxs },
            { name: i18n.t('Description2'), key: "characterization", align: "center", },
            { name: i18n.t('HPOFrequency'), key: "HPO_rate", align: "center", sort: true },
            { name: i18n.t('OrphanetFrequency'), key: "orphanet_rate", align: "center", sort: true },
            { name: i18n.t('HPOSourceAccession'), key: "source", align: "center" },
        ],
    };
};
